// @ts-nocheck
export default {
    getterWorkerDeliveryFeeGroupList: (state) => state.workerDeliveryFeeGroupList.map((it) => ({
        ...it,
    })),
    // 추후 값 맵핑을 위해 필요함.
    getterWorkerDeliveryFeeGroupOptionList: (state) => state.workerDeliveryFeeGroupOptionList.map((it) => ({
        ...it,
    })),
    getterSelectedFeeGroupId: (state) => state.selectedFeeGroup?.id,
    getterSelectedFeeGroupName: (state) => state.selectedFeeGroup?.name,
};
